import type { ElementClass } from "@dsk/types";
import { computed, onMounted, ref } from "vue";
import { onBeforeRouteLeave } from "vue-router";

interface PageFadeOptions {
  fadeIn?: boolean;
  fadeOut?: boolean;
}

export function usePageFade(options: PageFadeOptions = {}) {
  const FADE_IN_DELAY = 50;
  const FADE_OUT_DELAY = 75;

  const fadePageIn = ref<boolean>(false);
  const fadePageOut = ref<boolean>(false);

  const fadeInClass = computed<ElementClass>(() => {
    const baseClass = "page-fade-in";
    const classes = [baseClass];

    if (fadePageIn.value) {
      classes.push(`${baseClass}--active`);
    }

    return classes;
  });

  const fadeOutClass = computed<ElementClass>(() => {
    const baseClass = "page-fade-out";
    const classes = [baseClass];

    if (fadePageOut.value) {
      classes.push(`${baseClass}--active`);
    }

    return classes;
  });

  onMounted(() => {
    if (!options.fadeIn) {
      return;
    }

    setTimeout(() => {
      fadePageIn.value = true;
    }, FADE_IN_DELAY);
  });

  onBeforeRouteLeave(() => {
    if (!options.fadeOut) {
      return;
    }

    fadePageOut.value = true;

    setTimeout(() => {
      fadePageOut.value = false;
    }, FADE_OUT_DELAY);
  });

  return {
    fadeInClass,
    fadeOutClass
  };
}
